import Swal from 'sweetalert2';

export default new class Waiting {
  constructor() {
    const el = document.createElement('span');
    el.classList.add('ld', 'ld-ring', 'ld-spin');

    document.addEventListener('dialog-wait', (e) => {
      const isMessage = ((typeof e.detail || typeof e.detail.message) !== 'undefined'
        && e.detail.message);

      const isStatus = ((typeof e.detail || typeof e.detail.status) !== 'undefined'
        && e.detail.status);

      Swal.fire({
        html: isMessage || el,
        showConfirmButton: false,
        timer: isMessage ? 3000 : 10000,
        customClass: {
          popup: !isMessage ? 'waiting-dialog' : 'error-dialog',
          htmlContainer: isStatus ? 'success-message' : 'error-message',
        },
      });
    });

    document.addEventListener('dialog-close', () => {
      Swal.close();
    });
  }
}();
